module.exports = __webpack_public_path__ + "img/BGMain11.a9392cbb.jpg";